import { render, staticRenderFns } from "./SectionVideoInformation.vue?vue&type=template&id=12d7a754&scoped=true&"
import script from "./SectionVideoInformation.vue?vue&type=script&lang=js&"
export * from "./SectionVideoInformation.vue?vue&type=script&lang=js&"
import style0 from "./SectionVideoInformation.vue?vue&type=style&index=0&id=12d7a754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d7a754",
  null
  
)

export default component.exports